import {
  GETSUMMERYREPORTFILE_SUCCESS,
  GETSUMMERYREPORTFILE_FAILED,
  RESET_GETSUMMERYREPORTFILE,
  LOADING_GETSUMMERYREPORTFILE,
  NETWORK_ERROR_GETSUMMERYREPORTFILE,
} from "../types/index";

const initialState = {
  isLoading: false,
  success: false,
  network: false,
  failed: false,
  data: {},
  message: "",
  networkError: "",
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_GETSUMMERYREPORTFILE:
      return {
        ...state,
        isLoading: true,
        success: false,
        failed: false,
        network: false,
        data: {},
        message: "",
        networkError: "",
      };
    case GETSUMMERYREPORTFILE_FAILED:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: true,
        network: false,
        data: action.payload,
        message: "",
        networkError: "",
      };
    case GETSUMMERYREPORTFILE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        success: true,
        failed: false,
        network: false,
        data: action.payload,
        message: "",
        networkError: "",
      };
    case NETWORK_ERROR_GETSUMMERYREPORTFILE:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: false,
        network: true,
        data: {},
        message: "",
        networkError: "",
      };
    case RESET_GETSUMMERYREPORTFILE:
      return (state = initialState);
    default:
      return state;
  }
};
